import { render } from "./Token.vue?vue&type=template&id=8d6313bc"
import script from "./Token.vue?vue&type=script&lang=js"
export * from "./Token.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__